export default __webpack_public_path__ + "static/media/google-setup-1-tw.6d803676.jpeg";